import { FC, memo } from 'react';
import { TimeSwitchProps } from './TimeSwitch.types';
import styles from './TimeSwitch.module.scss';
import classNames from 'classnames';
import { ConfigProvider, Slider, Switch, Tooltip } from 'antd';
import { handleRichText } from '@/utils/handleRichText';

const TimeSwitch = memo((props: TimeSwitchProps) => {
  const changeTimeToInt = (time: 'MONTHLY' | 'YEARLY') => {
    const map = {
      MONTHLY: 0,
      YEARLY: 1
    };
    return map[time] as number;
  };

  const changeIntToTime = (curInt: number) => {
    const intList = ['MONTHLY', 'YEARLY'];
    props.onChange && props.onChange(intList[curInt]);
  };

  return (
    <div>
      <span
        className={classNames(styles.month, props.value === 'MONTHLY' && styles.active)}
        onClick={() => changeIntToTime(0)}
      >
        月繳
      </span>
      <div className={styles.time_slider}>
        <ConfigProvider
          theme={{
            components: {
              Slider: {
                // 滑块
                handleColor: '#E87722',
                handleLineWidth: 6,
                handleLineWidthHover: 6,
                handleSize: 8,
                handleSizeHover: 8,
                // 轨道
                railBg: '#E87722',
                railHoverBg: '#E87722',
                trackBg: '#E87722',
                trackHoverBg: '#E87722'
              }
            }
          }}
        >
          <Slider
            dots={true}
            min={0}
            max={1}
            tooltip={{ open: false }}
            onChange={changeIntToTime}
            value={changeTimeToInt(props.value || 'MONTHLY')}
          />
        </ConfigProvider>
      </div>
      <Tooltip
        getPopupContainer={trigger => document.getElementById('year') || document.body}
        open={true}
        zIndex={10}
        placement="topRight"
        autoAdjustOverflow={false}
        overlayInnerStyle={{
          padding: '4px 8px',
          minHeight: '26px',
          borderRadius: '8px',
          boxShadow: 'none'
        }}
        title={
          <div
            className={classNames(styles.rich_text, styles.tooltip)}
            id={'rich_text_wrapper'}
            dangerouslySetInnerHTML={{
              __html: handleRichText(props.tooltip)
            }}
          ></div>
        }
      >
        <span
          id="year"
          className={classNames(styles.year, props.value === 'YEARLY' && styles.active)}
          onClick={() => changeIntToTime(1)}
        >
          年繳
        </span>
      </Tooltip>
    </div>
  );
});
export default TimeSwitch;
